import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import {
  Row, Col, CardHeader, CardBody, Spinner, Alert, Input, Button,
} from "reactstrap"
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table"
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css"
import { toast } from "react-toastify"
import {
  adminGetPlans,
  adminDeletePlan,
} from "../../api/requests/subscription-requests"
import { SubscriptionDeleteModal } from "../modals/subscription/SubscriptionDeleteModal"




const TableCard = ({ className = "", children, ...rest }) => (
  <div
    className={`card rounded-4 border-0 shadow-lg ${className}`}
    style={{ boxShadow: "0 .5rem 1.25rem rgba(10,49,110,.08)" }}
    {...rest}
  >
    {children}
  </div>
)

const NAVY = "#221C5D"
const ORANGE = "#E56A22"




const SubscriptionPlans = () => {
  const navigate = useNavigate()
  const [plans, setPlans] = useState([])
  const [loading, setLoading] = useState(true)
  const [refreshing, setRefreshing] = useState(false)
  const [error, setError] = useState(null)
  const [searchTerm, setSearchTerm] = useState("")
  const [deletePlan, setDeletePlan] = useState(null)
  const [deleteModalOpen, setDeleteModalOpen] = useState(false)

  const styles = `
    .plans-modern .table thead tr { background-color: #f9f9f9; }
    .plans-modern .table th { border: 0; color: #6c757d; font-weight: 600; }
    .plans-modern .table td { vertical-align: middle; }
    .plans-modern .table-hover tbody tr:hover { background: #fcfcfd; }
    .plans-modern .search-input { width: 250px; }
    .plans-modern .header-actions { gap: .5rem; }
    .plans-modern .btn-rounded { border-radius: 999px; }
    .plans-modern .btn-navy { background: ${NAVY}; border-color: ${NAVY}; color: #fff; }
    .plans-modern .btn-navy:hover { filter: brightness(1.03); }
    .plans-modern .btn-orange { background: ${ORANGE}; border-color: ${ORANGE}; color: #fff; }
    .plans-modern .btn-orange:hover { filter: brightness(1.03); }
    .plans-modern .action-btn { border-radius: 999px; padding: .35rem .6rem; }
    .plans-modern .pill-input { border-radius: 999px !important; padding: .45rem .9rem; }
    @media (max-width: 576px) {
      .plans-modern .search-input { width: 100%; }
      .plans-modern .table { font-size: 12px; }
      .plans-modern .table td, .plans-modern .table th { padding: .5rem; }
    }
  `

  document.title = "Abonelik Paketleri | Tahsilat360"

  const loadPlans = async (first = false) => {
    try {
      setError(null)
      if (first) setLoading(true); else setRefreshing(true)
      const res = await adminGetPlans()
      setPlans(res.data || [])
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
      setRefreshing(false)
    }
  }

  useEffect(() => {
    loadPlans(true)
  }, [])


  const filteredPlans = plans.filter((p) => {
    if (!searchTerm) return true
    const s = searchTerm.toLowerCase()
    return (
      p.name?.toLowerCase().includes(s) ||
      p.description?.toLowerCase().includes(s)
    )
  })

  const handleDelete = async (id) => {
    try {
      // Backend kullanılmamış paketi gerçekten siler; aboneliği ya da fiyat
      // müdahalesi olan paketi silemeyip pasife alır. Hangisinin olduğunu
      // yalnız o bilir, bu yüzden mesajı sabitlemek yerine olduğu gibi gösteriyoruz.
      const res = await adminDeletePlan(id)
      const silindi = res?.message === "Paket silindi"
      if (silindi) toast.success(res.message)
      else toast.info(res?.message || "Paket pasife alındı")
      loadPlans()
    } catch (err) {
      toast.error(err.message)
    } finally {
      setDeleteModalOpen(false)
      setDeletePlan(null)
    }
  }

  const openCreate = () => navigate("/admin/subscription-plans/new")
  const openEdit = (plan) => navigate(`/admin/subscription-plans/${plan.id}/edit`)

  const formatPrice = (price) =>
    new Intl.NumberFormat("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(price) + " ₺"

  return (
    <div className="page-content plans-modern">
      <style>{styles}</style>
      <div className="container-fluid">
        <Row>
          <Col>
            <TableCard>
              <CardHeader className="bg-white border-0 rounded-top-4">
                {/* DESKTOP header */}
                <div className="d-none d-md-block">
                    <div className="d-flex justify-content-between align-items-start mb-3">
                        <div>
                            <h5 className="mb-1 fw-bold text-dark">Abonelik Paketleri</h5>
                            <p className="mb-0 text-muted" style={{ fontSize: ".9rem" }}>
                                {plans.length > 0 ? `Toplam ${plans.length} paket` : "Paket bulunamadı"}
                            </p>
                        </div>
                        <Button className="d-flex align-items-center gap-1 btn-rounded btn-navy" onClick={openCreate}>
                            <i className="bx bx-plus" /> Yeni Paket
                        </Button>
                    </div>
                    <div className="d-flex justify-content-end">
                        <Input
                            type="search"
                            placeholder="Paket ara..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="search-input pill-input"
                        />
                    </div>
                </div>
                {/* MOBILE header */}
                <div className="d-md-none">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <h5 className="mb-0 fw-semibold">Paketler</h5>
                    <Button size="sm" className="d-flex align-items-center gap-1 btn-rounded btn-navy" onClick={openCreate}>
                      <i className="bx bx-plus" /> Ekle
                    </Button>
                  </div>
                  <Input
                    type="search"
                    placeholder="Paket ara..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="pill-input mb-2"
                  />
                </div>
              </CardHeader>

              <CardBody className="pt-2">
                {error && (
                  <Alert color="danger" className="mb-3 rounded-4">
                    <i className="bx bx-error-circle me-2" />
                    {error}
                    <button className="btn btn-sm btn-outline-danger ms-2 btn-rounded" onClick={() => loadPlans()}>
                      Tekrar Dene
                    </button>
                  </Alert>
                )}

                {loading ? (
                  <div className="text-center p-5">
                    <Spinner size="lg" color="primary" />
                    <h6 className="mt-3 text-muted">Paketler yükleniyor...</h6>
                  </div>
                ) : (
                  <>
                    <div className={`d-flex justify-content-between align-items-center mb-2 ${refreshing ? "opacity-50" : ""}`}>
                      <div className="text-muted" style={{ fontSize: ".9rem" }}>
                        {filteredPlans.length > 0 && <>Toplam <strong>{filteredPlans.length}</strong> kayıt</>}
                      </div>
                      <button className="btn btn-light btn-sm btn-rounded" onClick={() => loadPlans()} title="Yenile">
                        <i className={`bx bx-refresh ${refreshing ? "bx-spin" : ""}`} />
                      </button>
                    </div>

                    <div className="table-responsive rounded-4 border">
                      <Table className="table table-hover mb-0">
                        <Thead>
                          <Tr>
                            <Th>Sira</Th>
                            <Th>Ad</Th>
                            <Th>Fiyat</Th>
                            <Th className="d-none d-sm-table-cell">Süre</Th>
                            <Th className="d-none d-md-table-cell">Kapsam</Th>
                            <Th className="d-none d-sm-table-cell">KDV</Th>
                            <Th className="d-none d-md-table-cell">Maks. Cari</Th>
                            <Th className="d-none d-md-table-cell">Maks. Alt / Cari Kullanıcı</Th>
                            <Th className="d-none d-lg-table-cell">Tahsilat Limiti</Th>
                            <Th className="d-none d-lg-table-cell">Özel Domain</Th>
                            <Th>Durum</Th>
                            <Th className="text-end">İşlemler</Th>
                          </Tr>
                        </Thead>
                        <Tbody>
                          {filteredPlans.length ? filteredPlans.map((plan) => (
                            <Tr key={plan.id} className="border-bottom">
                              <Td>{plan.sortOrder}</Td>
                              <Td className="fw-semibold text-dark">
                                {plan.name}
                                {plan.trial && (
                                  <span
                                    className="ms-2 d-inline-flex align-items-center"
                                    style={{ background: "#fff0e3", color: "#E8833A", fontWeight: 600, fontSize: ".68rem", padding: ".15rem .5rem", borderRadius: 999, border: "1px solid #f6d4b6" }}
                                    title="Deneme paketi — yeni firmalara otomatik atanır"
                                  >
                                    <i className="bx bx-time-five me-1" />
                                    Deneme{plan.trialDays ? ` · ${plan.trialDays}g` : ""}
                                  </span>
                                )}
                              </Td>
                              <Td>{formatPrice(plan.basePrice)}</Td>
                              <Td className="d-none d-sm-table-cell">{plan.durationLabel || "—"}</Td>
                              <Td className="d-none d-md-table-cell">
                                {plan.visibleToCustomers !== false ? (
                                  <span
                                    className="badge border-0"
                                    style={{ borderRadius: 999, background: "#EBF0F7", color: NAVY, fontWeight: 600 }}
                                    title={
                                      plan.assignedCompanyNames?.length
                                        ? `Herkese açık paket · aktif firmalar: ${plan.assignedCompanyNames.join(", ")}`
                                        : "Herkese açık paket — tüm firmaların satın-alma listesinde görünür"
                                    }
                                  >
                                    Genel
                                  </span>
                                ) : plan.assignedCompanyNames?.length ? (
                                  <span
                                    className="d-inline-block text-truncate"
                                    style={{ maxWidth: 180, fontSize: ".82rem" }}
                                    title={plan.assignedCompanyNames.join(", ")}
                                  >
                                    {plan.assignedCompanyNames[0]}
                                    {plan.assignedCompanyNames.length > 1 && (
                                      <span className="text-muted"> +{plan.assignedCompanyNames.length - 1}</span>
                                    )}
                                  </span>
                                ) : (
                                  <span className="text-muted" style={{ fontSize: ".82rem" }} title="Firmaya özel paket, henüz kimseye atanmamış">
                                    Atanmamış
                                  </span>
                                )}
                              </Td>
                              <Td className="d-none d-sm-table-cell">
                                %{plan.vatRate}
                                <span
                                  className="badge border-0 ms-1"
                                  style={{ borderRadius: 999, backgroundColor: plan.vatIncluded ? "#71C30B" : "#B0B7C3", color: "#fff" }}
                                >
                                  {plan.vatIncluded ? "Dahil" : "Hariç"}
                                </span>
                              </Td>
                              <Td className="d-none d-md-table-cell">{plan.maxAccounts || "Sınırsız"}</Td>
                              <Td className="d-none d-md-table-cell">
                                {plan.maxUsers || "Sınırsız"}
                                <div className="text-muted" style={{ fontSize: ".72rem" }}>
                                  cari: {plan.maxAccountUsers || "Sınırsız"}
                                </div>
                              </Td>
                              <Td className="d-none d-lg-table-cell">
                                {plan.maxCollectionAmount || plan.maxCollectionCount ? (
                                  <div style={{ fontSize: ".78rem" }}>
                                    {plan.maxCollectionAmount && (
                                      <div>{Number(plan.maxCollectionAmount).toLocaleString("tr-TR")} ₺</div>
                                    )}
                                    {plan.maxCollectionCount && <div>{plan.maxCollectionCount} işlem</div>}
                                    <div className="text-muted" style={{ fontSize: ".68rem" }}>
                                      {plan.collectionLimitPeriod === "MONTHLY" ? "her ay" : "dönem toplamı"}
                                    </div>
                                  </div>
                                ) : (
                                  "Sınırsız"
                                )}
                              </Td>
                              <Td className="d-none d-lg-table-cell">
                                <span
                                  className="badge border-0"
                                  style={{ borderRadius: 999, backgroundColor: plan.allowCustomDomain ? "#71C30B" : "#B0B7C3", color: "#fff" }}
                                >
                                  {plan.allowCustomDomain ? "Evet" : "Hayır"}
                                </span>
                              </Td>
                              <Td>
                                <span
                                  className="badge border-0"
                                  style={{ borderRadius: 999, backgroundColor: plan.active ? "#71C30B" : "#E07A7A", color: "#fff" }}
                                >
                                  {plan.active ? "Aktif" : "Pasif"}
                                </span>
                              </Td>
                              <Td className="text-end">
                                <div className="d-flex gap-1 justify-content-end flex-wrap">
                                  <button className="btn btn-sm action-btn btn-navy" title="Düzenle" onClick={() => openEdit(plan)}>
                                    <i className="bx bx-edit" />
                                  </button>
                                  <button
                                    className="btn btn-sm action-btn"
                                    style={{ background: "#dc3545", borderColor: "#dc3545", color: "#fff" }}
                                    title="Sil"
                                    onClick={() => { setDeletePlan(plan); setDeleteModalOpen(true) }}
                                  >
                                    <i className="bx bx-trash" />
                                  </button>
                                </div>
                              </Td>
                            </Tr>
                          )) : (
                            <Tr>
                              <Td colSpan="12" className="text-center py-4">
                                <div className="text-muted">
                                  <i className="bx bx-package display-4 d-block mb-2" />
                                  Paket bulunamadı
                                  {searchTerm && <div className="mt-2"><small>Arama teriminizi değiştirmeyi deneyin</small></div>}
                                </div>
                              </Td>
                            </Tr>
                          )}
                        </Tbody>
                      </Table>
                    </div>
                  </>
                )}
              </CardBody>
            </TableCard>
          </Col>
        </Row>
      </div>


      <SubscriptionDeleteModal
        isOpen={deleteModalOpen}
        toggle={() => { setDeleteModalOpen(false); setDeletePlan(null) }}
        title="Paket Silme Onayı"
        icon="bx-package"
        message="Bu paket silinecek. Aboneliği veya fiyat müdahalesi varsa geçmiş kayıtlar korunsun diye silinmez, yalnızca pasife alınır."
        item={deletePlan}
        renderInfo={(plan) => (
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h6 className="mb-1 text-dark">{plan.name}</h6>
              <div className="text-muted small">{plan.durationLabel || "—"} · {formatPrice(plan.basePrice)}</div>
            </div>
            <span className="badge border-0" style={{ borderRadius: 999, backgroundColor: plan.active ? "#71C30B" : "#E07A7A", color: "#fff" }}>
              {plan.active ? "Aktif" : "Pasif"}
            </span>
          </div>
        )}
        onConfirm={handleDelete}
      />
    </div>
  )
}

export default SubscriptionPlans
